import { useCreateAdjustmentBase } from "./useCreateAdjustmentBase"

import type {
  CreateCombinePalletsInput,
  CreateInventoryCombinePalletsAdjustmentMutation,
  CreateInventoryCombinePalletsAdjustmentMutationVariables,
} from "@/graphql/codegen/graphql"
import { CreateInventoryCombinePalletsAdjustmentDocument } from "@/graphql/codegen/graphql"

interface UseCreateCombinePalletsAdjustmentReturn {
  createAdjustment: (input: CreateCombinePalletsInput, comment?: string, document?: File) => Promise<boolean>
  isCreating: boolean
}

export const useCreateCombinePalletsAdjustment = (): UseCreateCombinePalletsAdjustmentReturn =>
  useCreateAdjustmentBase<
    CreateInventoryCombinePalletsAdjustmentMutation,
    CreateInventoryCombinePalletsAdjustmentMutationVariables,
    CreateCombinePalletsInput
  >({
    documentNode: CreateInventoryCombinePalletsAdjustmentDocument,
    getOutput: (data) => data.inventoryAdjustment.combinePallets,
  })
